import { useEffect, useState } from 'react';
import { IProduct, INutrient } from '@interfaces';
import { nominations } from '@components/common/products/utils';

import { apiImageSource } from '@v2/utils/http';
import ProductService from '@v2/services/product.service';

import styles from '@components/common/products/product.styles';
import { ContentLoader } from '../../presentational/loader/loader';

export default function ProductNutrients({ product }: { product?: IProduct }) {
    const [nutrients, setNutrients] = useState(product.nutrients);

    useEffect(() => {
        if (!product.nutrients) {
            ProductService
                .nutrients(product.id)
                .then(setNutrients);
        } else {
            setNutrients(product.nutrients);
        }
    }, [product]);

    return (
        <div className={styles.nutrients}>
            <div className="pdp-facts animated-container" {...{ animationtrigger: 1.4 }}>
                <div className="pdp-facts-wrapp wrapp">
                    <div className="pdp-facts-text animated "
                        {...{ animations: "animate__animated animate__fadeInUp-home animate__delay-01s" }}>
                        <h3>nutrients</h3>
                        <h2>key brain-supporting nutrients</h2>
                        <p className="pdp-sub-heading mt-3">
                            Every one of our Cerebelly products provides key nutrients your little one’s
                            developing brain needs during it's most important (and exciting!) stages of growth.
                            Each of these nutrients play a role in helping your little one reach their next milestone,
                            from saying mama for the first time to picking up a toy or taking their first steps.
                        </p>
                    </div>
                    <div className="pdp-facts-table animated "
                        {...{ animations: "animate__animated animate__fadeInUp-home animate__delay-03s" }}>
                        <table cellSpacing="0" cellPadding="0">
                            <thead>
                                <tr><th></th>
                                    <th></th>
                                    <th>us</th>
                                    <th>them*</th>
                                </tr></thead>
                            <tbody>
                                <ContentLoader loading={!nutrients}>
                                    {nutrients &&
                                        nutrients.map((nutrient: INutrient, key: number) =>
                                            nutrient.isKey ?
                                            <tr key={key}>
                                                <td className="title">{nutrient.title}</td>
                                                <td className="image">
                                                    <img src={apiImageSource(`nutrient?id=${nutrient.id}`)} alt={''} />
                                                </td>
                                                <td className="value">{nutrient.cerebellyValue}</td>
                                                <td className="value">{nutrient.themValue}</td>
                                            </tr> : null)}
                                </ContentLoader>
                            </tbody>
                        </table>
                    </div>
                    <p className="disclaimer mt-3">{nominations(product.category)}</p>
                </div>
            </div>
        </div>
    );
}